<template>
	<section v-if="show" id="development">
        <span class="alert">Entorn de proves</span>
        <span class="date">Última actualització: <strong>{{date}}</strong></span>
    </section>
</template>

<script>

export default {
  data () {
    return {
        show: process.env.VUE_APP_ENVIRONMENT == 'development',
        date: process.env.VUE_APP_LAST_UPDATE
    }
  },
  computed: {
   
  },
  methods: {
  	
  },
  created() {
      
  }
}
</script>

<style lang="scss" scoped>

	#development {
		width: 100%;
		height: $height-development;
        position: fixed;
        top: 0;
        background-color: #ffc107;
        z-index: 999999;
        text-align: center;

        .alert {
            @include background( $image: img('warning.svg'), $size: 20px, $position: left center );
            padding-left: 30px;
            line-height: $height-development;
            font-family: AvantGarde-Bold;
            font-size: 14px;
            font-weight: bold;
            text-transform: uppercase;
        }

        .date {
            margin-left: 20px;
            font-size: 12px;
            font-weight: lighter;
        }
	}

</style>
